import { AboutContentPagesModule } from '../components/modules/about-content-pages/about-content-pages-module';
import { AboutUsModule } from '../components/modules/about-us/about-us-module';
import { ArticlesModule } from '../components/modules/articles/articles-module';
import { CompanyRecommendationsModule } from '../components/modules/company-recommendations/company-recommendations-module';
import { ContactsModule } from '../components/modules/contacts/contacts-module';
import { EmployeesModule } from '../components/modules/employees/employees-module';
import { IdealEmployerModule } from '../components/modules/ideal-employer/ideal-employer-module';
import { JobsModule } from '../components/modules/jobs/jobs-module';
import { LocationsModule } from '../components/modules/locations/locations-module';
import { NewsModule } from '../components/modules/news/news-module';

type modulesMapProps = {
  [name: string]: React.ComponentType;
};

export const modulesMap: modulesMapProps = {
  about_content_pages: AboutContentPagesModule,
  about_us: AboutUsModule,
  jobs: JobsModule,
  ideal_employer: IdealEmployerModule,
  news: NewsModule,
  articles: ArticlesModule,
  contacts: ContactsModule,
  employees: EmployeesModule,
  company_recommendations: CompanyRecommendationsModule,
  locations: LocationsModule,
};
